export default __webpack_public_path__ + "static/media/robbery2.8888ab04.png";